var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "32px",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0178960241 0.0225167165 7.72459311 0.0225167165 7.72459311 5.84363167 0.0178960241 5.84363167"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0270967421 0.0225167165 7.73376285 0.0225167165 7.73376285 5.84365955 0.0270967421 5.84365955"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "1.39422393e-05 0.0564312135 29.6409916 0.0564312135 29.6409916 29.6973531 1.39422393e-05 29.6973531"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tom",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58724783,1.13526078 C5.46783255,0.936653578 5.51690923,0.689387964 5.69627614,0.585797126 C5.87564305,0.482206288 6.12012022,0.560003983 6.2395355,0.758680893 L6.44845995,1.10605179 C6.56787523,1.3047287 6.51879855,1.55199431 6.33943164,1.65551544 C6.16006473,1.75910627 5.91558757,1.68130858 5.79610258,1.48270138 L5.58724783,1.13526078 Z",
    id: "Fill-1",
    fill: "#377192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0457688,1.13317641 C24.1623259,0.932826433 24.1108791,0.684166596 23.9315122,0.580575758 C23.7521453,0.477054631 23.5099686,0.55624655 23.3934811,0.756596529 L23.209095,1.07350363 C23.0925379,1.27385361 23.1439848,1.52251344 23.3233517,1.62610428 C23.5027186,1.72962541 23.7448953,1.6505032 23.8613827,1.45015322 L24.0457688,1.13317641 Z",
    id: "Fill-3",
    fill: "#004060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(3.485560, 0.047194)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.563231612,5.84363167 C0.58295988,5.82362456 0.602200171,5.80326889 0.622067862,5.78333148 C2.60716389,3.79823545 5.05625765,2.44632622 7.72459311,1.82687253 L7.5109283,1.4568455 C6.7208216,0.0883449993 4.95468843,-0.384924314 3.58618794,0.405182387 L1.4522585,1.63725807 C0.0837580026,2.42736477 -0.38951131,4.19349794 0.400595391,5.56199844 L0.563231612,5.84363167 Z",
    id: "Fill-5",
    fill: "#377192",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(18.403756, 0.047194)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12962199,5.78335937 C7.14948969,5.80322706 7.16866026,5.82365244 7.18845824,5.84365955 L7.35109447,5.56195661 C8.14113146,4.19345611 7.66793185,2.42732295 6.29943136,1.63721625 L4.16550192,0.405210272 C2.79700142,-0.384896429 1.03086826,0.0883728838 0.240761559,1.45687338 L0.0270967421,1.8268307 C2.69543221,2.44628439 5.14452596,3.79826334 7.12962199,5.78335937",
    id: "Fill-8",
    fill: "#004060",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.6551568,16.5523799 C28.6551568,24.1930058 22.4611776,30.3869851 14.8204819,30.3869851 C7.17985588,30.3869851 0.985876654,24.1930058 0.985876654,16.5523799 C0.985876654,8.91175388 7.17985588,2.71777465 14.8204819,2.71777465 C22.4611776,2.71777465 28.6551568,8.91175388 28.6551568,16.5523799",
    id: "Fill-11",
    fill: "#D6EDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0993406,29.7945375 C8.01445227,29.7945375 2.25052141,24.0306066 2.25052141,16.9457183 C2.25052141,9.8608997 8.01445227,4.09689913 15.0993406,4.09689913 C22.1842289,4.09689913 27.9481598,9.8608997 27.9481598,16.9457183 C27.9481598,24.0306066 22.1842289,29.7945375 15.0993406,29.7945375 M15.0993406,3.4522797 C7.65899488,3.4522797 1.60590198,9.50544231 1.60590198,16.9457183 C1.60590198,24.386064 7.65899488,30.4392266 15.0993406,30.4392266 C22.5396863,30.4392266 28.5927792,24.386064 28.5927792,16.9457183 C28.5927792,9.50544231 22.5396863,3.4522797 15.0993406,3.4522797",
    id: "Fill-13",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 1.859686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73501465,5.79143192 C0.725219519,10.8012271 0.72528923,18.952627 5.73501465,23.9623524 C10.7447401,28.9721475 18.8962097,28.9721475 23.9060048,23.9623524 C28.9157303,18.952627 28.9157303,10.8011573 23.9059351,5.79143192 C18.8962097,0.781706502 10.7448098,0.78163679 5.73501465,5.79143192 M25.3001591,25.3565763 C22.500906,28.1558294 18.7791646,29.6973531 14.8204749,29.6973531 C10.8617852,29.6973531 7.14004382,28.1557597 4.34079072,25.3565763 C1.54160734,22.5573929 1.39422393e-05,18.8355819 1.39422393e-05,14.8768922 C1.39422393e-05,10.9182024 1.54160734,7.19646109 4.34079072,4.397208 C7.14004382,1.59802461 10.8617852,0.0564312135 14.8204749,0.0564312135 C18.7791646,0.0564312135 22.500906,1.59802461 25.3001591,4.397208 C28.0994121,7.19646109 29.6410055,10.9182024 29.6410055,14.8768922 C29.6410055,18.8355819 28.0994121,22.5573232 25.3001591,25.3565763",
    id: "Fill-15",
    fill: "#004060",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0197234,7.85667492 C15.2314363,7.85667492 15.4030653,7.68504595 15.4030653,7.47333305 L15.4030653,5.33570892 C15.4030653,5.12392631 15.2314363,4.95229734 15.0197234,4.95229734 C14.8080105,4.95229734 14.6363816,5.12392631 14.6363816,5.33570892 L14.6363816,7.47333305 C14.6363816,7.68504595 14.8080105,7.85667492 15.0197234,7.85667492",
    id: "Fill-18",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0197234,26.0148313 C14.8080105,26.0148313 14.6363816,26.1864602 14.6363816,26.3981731 L14.6363816,28.5357973 C14.6363816,28.7475799 14.8080105,28.9192088 15.0197234,28.9192088 C15.2314363,28.9192088 15.4030653,28.7475799 15.4030653,28.5357973 L15.4030653,26.3981731 C15.4030653,26.1864602 15.2314363,26.0148313 15.0197234,26.0148313",
    id: "Fill-20",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9405372,16.9357496 C5.9405372,16.7240367 5.76890824,16.5524077 5.55719533,16.5524077 L3.41964092,16.5524077 C3.20792801,16.5524077 3.03622934,16.7240367 3.03622934,16.9357496 C3.03622934,17.1474625 3.20792801,17.3190915 3.41964092,17.3190915 L5.55719533,17.3190915 C5.76890824,17.3190915 5.9405372,17.1474625 5.9405372,16.9357496",
    id: "Fill-22",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6197084,16.5523799 L24.4821539,16.5523799 C24.270441,16.5523799 24.0988121,16.7240088 24.0988121,16.9357217 C24.0988121,17.1474346 24.270441,17.3191333 24.4821539,17.3191333 L26.6197084,17.3191333 C26.8314213,17.3191333 27.0030502,17.1474346 27.0030502,16.9357217 C27.0030502,16.7240088 26.8314213,16.5523799 26.6197084,16.5523799",
    id: "Fill-24",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31017428,6.8362006 C9.28145327,6.78628738 9.21766752,6.768999 9.16733604,6.79799886 C9.1172834,6.8268593 9.10020415,6.89078446 9.12906459,6.9408371 L9.69463153,7.92034913 C9.71394153,7.95394992 9.74907597,7.97263252 9.78525608,7.97263252 C9.80296273,7.97263252 9.82094821,7.96810129 9.83746977,7.95862057 C9.8874527,7.92969043 9.90460165,7.86583497 9.8756715,7.81571262 L9.31017428,6.8362006 Z",
    id: "Fill-26",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3447317,25.9485987 C20.315941,25.8988249 20.2523643,25.8816062 20.2018934,25.9103969 C20.1519105,25.9392574 20.1347616,26.0031825 20.163622,26.0532352 L20.7291889,27.0327472 C20.7484989,27.066348 20.7836334,27.0850306 20.8198135,27.0850306 C20.8375201,27.0850306 20.8555056,27.0804994 20.8720272,27.0710186 C20.9220101,27.0420885 20.9391591,26.978233 20.9102289,26.9281107 L20.3447317,25.9485987 Z",
    id: "Fill-28",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90095519,22.0785049 L4.92144316,22.6440021 C4.87146024,22.6729323 4.85431128,22.7367877 4.88317172,22.7869101 C4.90255143,22.8204412 4.93768587,22.8391238 4.97386598,22.8391238 C4.99150292,22.8391238 5.00955812,22.8346623 5.02607967,22.8251118 L6.00559169,22.2596146 C6.05557462,22.2306845 6.07272357,22.166829 6.04379343,22.1167066 C6.0150027,22.0667237 5.9514958,22.0497142 5.90095519,22.0785049",
    id: "Fill-30",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0861665,11.8045733 C24.1038731,11.8045733 24.1218586,11.8001118 24.1383801,11.7905614 L25.1179619,11.2250642 C25.1679448,11.196134 25.185024,11.1322786 25.1561636,11.0821562 C25.1273729,11.0323127 25.063866,11.0149546 25.0132557,11.0439545 L24.0337436,11.6095214 C23.9837607,11.6383818 23.9666118,11.7022373 23.9955419,11.7523597 C24.0148519,11.7858907 24.0499863,11.8045733 24.0861665,11.8045733",
    id: "Fill-32",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00559866,11.6094866 L5.02608664,11.0439196 C4.97547631,11.0147106 4.91196941,11.0320687 4.88317869,11.0821911 C4.85431825,11.1322437 4.8713975,11.1961689 4.92145014,11.2250293 L5.90096216,11.7905962 C5.91748371,11.800077 5.9354692,11.8045385 5.95317584,11.8045385 C5.98935595,11.8045385 6.0244904,11.7859256 6.0438004,11.7523248 C6.07273054,11.7022722 6.05558159,11.638347 6.00559866,11.6094866",
    id: "Fill-34",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.117927,22.64403 L24.138415,22.0785328 C24.0878047,22.0493935 24.0242978,22.0666122 23.995507,22.1167345 C23.9666466,22.1667872 23.9837259,22.2307123 24.0337785,22.2595728 L25.0132905,22.8251397 C25.0298121,22.8346204 25.0477976,22.8391517 25.0655042,22.8391517 C25.1016843,22.8391517 25.1368188,22.8204691 25.1561288,22.7868683 C25.1850589,22.7368156 25.1679099,22.6728905 25.117927,22.64403",
    id: "Fill-36",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83747674,25.910376 C9.78700583,25.8813064 9.72342922,25.8985948 9.6946385,25.9485777 L9.12907156,26.9281595 C9.10021113,26.9782121 9.11729037,27.0421373 9.1672733,27.0709977 C9.18386456,27.0805482 9.20185005,27.0850097 9.21955669,27.0850097 C9.2557368,27.0850097 9.29080154,27.0663271 9.31018125,27.032796 L9.87567847,26.0532143 C9.90460862,26.0031616 9.88745967,25.9392364 9.83747674,25.910376",
    id: "Fill-38",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8720341,6.79797795 C20.8216329,6.76869925 20.7580563,6.78619676 20.7291959,6.83617968 L20.163629,7.81576142 C20.1347685,7.86581406 20.1518478,7.92973922 20.2019004,7.95859966 C20.218422,7.96815009 20.2364075,7.97261161 20.2541141,7.97261161 C20.2902942,7.97261161 20.3253589,7.95392901 20.3447387,7.92039792 L20.9102359,6.94081619 C20.939166,6.89076355 20.9220171,6.82683838 20.8720341,6.79797795",
    id: "Fill-40",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2306418,16.9357636 C16.2306418,17.6045728 15.6884978,18.1467167 15.0196886,18.1467167 C14.3508794,18.1467167 13.8087354,17.6045728 13.8087354,16.9357636 C13.8087354,16.2669543 14.3508794,15.7248104 15.0196886,15.7248104 C15.6884978,15.7248104 16.2306418,16.2669543 16.2306418,16.9357636",
    id: "Fill-44",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7182436,16.9357636 C15.7182436,17.3215453 15.4055191,17.6343395 15.0196677,17.6343395 C14.6338859,17.6343395 14.3210918,17.3215453 14.3210918,16.9357636 C14.3210918,16.5499818 14.6338859,16.2371877 15.0196677,16.2371877 C15.4055191,16.2371877 15.7182436,16.5499818 15.7182436,16.9357636",
    id: "Fill-46",
    fill: "#B5D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8204958,29.5854039 C7.73560748,29.5854039 1.97167663,23.821473 1.97167663,16.7365847 C1.97167663,9.65176611 7.73560748,3.88776554 14.8204958,3.88776554 L14.8204958,1.91612377 C10.8618061,1.91612377 7.14006473,3.45771717 4.34081164,6.25690055 C1.54162825,9.05615365 3.48555982e-05,12.777895 3.48555982e-05,16.7365847 C3.48555982e-05,20.6952744 1.54162825,24.4170855 4.34081164,27.2162689 C7.14006473,30.015522 10.8618061,31.5571154 14.8204958,31.5571154 L14.8204958,29.5854039 Z",
    id: "Fill-48",
    fill: "#377192"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.8356541,
    y1: 5.13652312,
    x2: 14.8356541,
    y2: 7.27407754,
    id: "Stroke-52",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.8356541,
    y1: 26.199064,
    x2: 14.8356541,
    y2: 28.3366184,
    id: "Stroke-54",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.2204342,
    y1: 16.7517291,
    x2: 5.35798862,
    y2: 16.7517291,
    id: "Stroke-56",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.282996,
    y1: 16.7517291,
    x2: 26.4205504,
    y2: 16.7517291,
    id: "Stroke-58",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.02047546,
    y1: 6.68938185,
    x2: 9.5860424,
    y2: 7.66889387,
    id: "Stroke-60",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.055012,
    y1: 25.8017381,
    x2: 20.6205092,
    y2: 26.7812501,
    id: "Stroke-62",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.77454773,
    y1: 22.5353572,
    x2: 5.75405975,
    y2: 21.9697903,
    id: "Stroke-64",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.8869319,
    y1: 11.5008347,
    x2: 24.8664439,
    y2: 10.9352677,
    id: "Stroke-66",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.77454773,
    y1: 10.9352956,
    x2: 5.75405975,
    y2: 11.5008626,
    id: "Stroke-68",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.8869319,
    y1: 21.9698252,
    x2: 24.8664439,
    y2: 22.5353921,
    id: "Stroke-70",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.02047546,
    y1: 26.781278,
    x2: 9.5860424,
    y2: 25.801766,
    id: "Stroke-72",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.055012,
    y1: 7.66891478,
    x2: 20.6205092,
    y2: 6.68940276,
    id: "Stroke-74",
    stroke: "#00375A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0314629,16.7365847 C16.0314629,17.4053939 15.489319,17.9475379 14.8205097,17.9475379 C14.1517005,17.9475379 13.6095566,17.4053939 13.6095566,16.7365847 C13.6095566,16.0677755 14.1517005,15.5256315 14.8205097,15.5256315 C15.489319,15.5256315 16.0314629,16.0677755 16.0314629,16.7365847",
    id: "Fill-76",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.8205097,
    y1: 16.7365847,
    x2: 18.5757822,
    y2: 12.8542985,
    id: "Stroke-78",
    stroke: "#F26F21",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.8204958,
    y1: 16.7365847,
    x2: 8.02616375,
    y2: 12.8542985,
    id: "Stroke-80",
    stroke: "#F26F21",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5190647,16.7365847 C15.5190647,17.1223665 15.2063403,17.4351606 14.8204888,17.4351606 C14.4347071,17.4351606 14.1219826,17.1223665 14.1219826,16.7365847 C14.1219826,16.350803 14.4347071,16.0380088 14.8204888,16.0380088 C15.2063403,16.0380088 15.5190647,16.350803 15.5190647,16.7365847",
    id: "Fill-82",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21437644,30.0298616 C3.82901295,30.5802315 3.91615194,31.3123385 4.40803414,31.6567118 C4.89984664,32.0011548 5.61759311,31.8326628 6.00302632,31.2822929 L7.59174449,29.0132632 C7.97717769,28.4628933 7.8900387,27.7307863 7.39815649,27.386413 C6.90627429,27.04197 6.18852781,27.2104619 5.80316432,27.7608318 L4.21437644,30.0298616 Z",
    id: "Fill-84",
    fill: "#377192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4301426,30.0269058 C25.815506,30.5772757 25.7283671,31.3093827 25.2364848,31.653756 C24.7446724,31.998199 24.0269259,31.8297071 23.6414927,31.2793372 L22.0830292,29.0535284 C21.6976657,28.5031585 21.7848047,27.7710515 22.2766869,27.4266782 C22.7684994,27.0822352 23.4862458,27.2507968 23.871679,27.8011667 L25.4301426,30.0269058 Z",
    id: "Fill-86",
    fill: "#004060"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.81f7ce168bc1ad3a86d2bdf98922d298.svg";
export { ForwardRef as ReactComponent };